<h3 class="itinerario-title">Itinerario</h3>
<div *ngIf="modifications" class="itinerario-switch-container">
    <mat-slide-toggle color="primary" (change)="onModificationsSwitch()" [checked]="!disableModifications">
        <span>Effettua modifiche</span>
    </mat-slide-toggle>
</div>
<div class="itinerario-switch-container">
    <mat-slide-toggle color="primary" (change)="onRoundTripSwitch()" [checked]="roundtrip"
        [disabled]="modifications && disableModifications">
        <span>Andata-ritorno</span>
    </mat-slide-toggle>
</div>
<div class="itinerario" *ngFor="let item of itinerario; index as idx">
    <div>
        <button mat-icon-button class="itinerario-btn" aria-label="Cancella riga itinerario"
            (click)="onDeleteItineraryClick(idx)"
            [disabled]="checkShouldDisableItineraryDelete() || (modifications && disableModifications)">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
    <div class="itinerario-from">
        <input type="text" class="form-control itinerario-input" (change)="updateItineraryFrom($event, idx)"
            [value]="itinerario[idx].da" maxlength="50" placeholder="Da" (keydown)="omitSpecialCharacters($event)"
            [disabled]="modifications && disableModifications">
    </div>
    <div class="itinerario-to">
        <input type="text" class="form-control itinerario-input" (change)="updateItineraryTo($event, idx)"
            [value]="itinerario[idx].a" maxlength="50" placeholder="A" (keydown)="omitSpecialCharacters($event)"
            [disabled]="modifications && disableModifications">
    </div>
</div>
<div class="itinerario-add">
    <button mat-icon-button class="itinerario-btn" aria-label="Aggiungi riga nuova" (click)="onAddItineraryClick()"
        [disabled]="checkShouldDisableItineraryAdd() || (modifications && disableModifications)">
        <mat-icon>add</mat-icon>
    </button>
</div>